/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { RegistryApplicationImage } from './RegistryApplicationImage'
import {
  RegistryApplicationImageFromJSON,
  RegistryApplicationImageFromJSONTyped,
  RegistryApplicationImageToJSON,
} from './RegistryApplicationImage'

/**
 *
 * @export
 * @interface RegistryInfo
 */
export interface RegistryInfo {
  /**
   *
   * @type {RegistryApplicationImage}
   * @memberof RegistryInfo
   */
  image: RegistryApplicationImage
  /**
   *
   * @type {string}
   * @memberof RegistryInfo
   */
  registrationNumber: string
  /**
   *
   * @type {string}
   * @memberof RegistryInfo
   */
  rightholderAddress: string
  /**
   *
   * @type {string}
   * @memberof RegistryInfo
   */
  rightholderName: string
}

/**
 * Check if a given object implements the RegistryInfo interface.
 */
export function instanceOfRegistryInfo(value: object): value is RegistryInfo {
  if (!('image' in value) || value['image'] === undefined) return false
  if (
    !('registrationNumber' in value) ||
    value['registrationNumber'] === undefined
  )
    return false
  if (
    !('rightholderAddress' in value) ||
    value['rightholderAddress'] === undefined
  )
    return false
  if (!('rightholderName' in value) || value['rightholderName'] === undefined)
    return false
  return true
}

export function RegistryInfoFromJSON(json: any): RegistryInfo {
  return RegistryInfoFromJSONTyped(json, false)
}

export function RegistryInfoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): RegistryInfo {
  if (json == null) {
    return json
  }
  return {
    image: RegistryApplicationImageFromJSON(json['image']),
    registrationNumber: json['registrationNumber'],
    rightholderAddress: json['rightholderAddress'],
    rightholderName: json['rightholderName'],
  }
}

export function RegistryInfoToJSON(value?: RegistryInfo | null): any {
  if (value == null) {
    return value
  }
  return {
    image: RegistryApplicationImageToJSON(value['image']),
    registrationNumber: value['registrationNumber'],
    rightholderAddress: value['rightholderAddress'],
    rightholderName: value['rightholderName'],
  }
}
